import { render, staticRenderFns } from "./TheSourceButton.vue?vue&type=template&id=31f560ae&scoped=true&"
import script from "./TheSourceButton.vue?vue&type=script&lang=js&"
export * from "./TheSourceButton.vue?vue&type=script&lang=js&"
import style0 from "./TheSourceButton.vue?vue&type=style&index=0&id=31f560ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f560ae",
  null
  
)

export default component.exports